import { BaseFCProps, FC, Modal } from "../components";

export interface CustomModalProps extends BaseFCProps {
  action?: "click" | "touchstart";
  onShow?: (e?: Event) => void;
  onHide?: (e?: Event) => void;
  onShown?: (e?: Event) => void;
  onHidden?: (e?: Event) => void;
}

export const CustomModalTouch: FC = ({ 
  selector = '[data-bs-toggle-touch="modal"]',
  onShow,
  onHide,
  onShown,
  onHidden,
  ...props
}: CustomModalProps = {}) => {
  Array.from(document.querySelectorAll(selector)).forEach((node) => {
    const target = node as HTMLElement;
    const modalEl = document.querySelector(target.dataset.bsTarget || '');
    if (modalEl === null) throw new Error('ERROR_MODAL_NOT_FOUND');
    const modal = Modal.create({
      action: 'touchstart',
      target: target.dataset.bsTarget!,
      trigger: target,
      onShow,
      onHide,
      onShown,
      onHidden,
      ...props,
    });
    modal.render();
  });
};